(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7436,3415],{

/***/ 85080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ getReviewsReactions; }
/* harmony export */ });
/* harmony import */ var _api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65255);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7181);
/* harmony import */ var _constants_request_method__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17028);
/* harmony import */ var url_join__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26509);




const getReviewsReactions = async (commentIds, header)=>{
    const path = (0,url_join__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("v1/reaction/check");
    const response = await (0,_api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__/* .createFetcher */ .gt)(()=>({
            apiUrl: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .MEEY_REVIEW_API_URL */ .HG
        }))(_constants_request_method__WEBPACK_IMPORTED_MODULE_2__/* ["default"].POST */ .Z.POST, path, {
        commentIds
    }, header);
    return response;
};


/***/ }),

/***/ 14759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



const MeeyRate = (param)=>{
    let { numberOfStar =5 , value =0 , onChange , className , itemClassName , disable =false  } = param;
    const [hoverIndex, setHoverIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(-1);
    const renderStar = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const array = [];
        for(let i = 0; i < numberOfStar; i++){
            const isActveStar = i <= value - 1;
            array.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                onMouseMove: ()=>setHoverIndex(i),
                onMouseLeave: ()=>setHoverIndex(-1),
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("mrv mrv-star text-[40px] duration-200", isActveStar ? "text-[#FFC633]" : "text-grey-300", i <= hoverIndex && !disable ? "md:scale-[1.1] md:!text-[#FFC633]" : "", disable ? "cursor-default" : "cursor-pointer", itemClassName),
                onClick: ()=>{
                    if (disable) return;
                    if (i === value - 1) onChange && onChange(0);
                    else onChange && onChange(i + 1);
                }
            }, i));
        }
        return array;
    }, [
        disable,
        hoverIndex,
        itemClassName,
        numberOfStar,
        onChange,
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex", className),
        children: renderStar
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MeeyRate);


/***/ }),

/***/ 52591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useAnimateState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1303);
/* harmony import */ var _vendor_scroll_locker_useScrollLocker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77027);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);





const Modal = (param)=>{
    let { className , header , headerClassName , contentClassName , footerClassName , bodyClassName , footer , open , children , onClose  } = param;
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(open);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        setIsOpen(open);
    }, [
        open
    ]);
    const { trigger , triggerClose  } = (0,_hooks_useAnimateState__WEBPACK_IMPORTED_MODULE_1__/* .useAnimateState */ .T)({
        open: isOpen,
        handleClose: ()=>{
            onClose ? onClose() : setIsOpen(false);
        }
    });
    const handleClose = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((e)=>{
        if (e.type === "keydown" && e.key === "Escape" || e.type === "click" || e.type === "mousedown") {
            triggerClose();
        }
    }, [
        triggerClose
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (isOpen) {
            (0,_vendor_scroll_locker_useScrollLocker__WEBPACK_IMPORTED_MODULE_2__/* .lockScroll */ .dg)();
            window.addEventListener("keydown", handleClose);
        }
        return ()=>{
            (0,_vendor_scroll_locker_useScrollLocker__WEBPACK_IMPORTED_MODULE_2__/* .unlockScroll */ .pX)();
            window.removeEventListener("keydown", handleClose);
        };
    }, [
        isOpen,
        handleClose
    ]);
    return isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("wrap-modal duration-300", className, trigger ? "opacity-100" : "opacity-0"),
        onMouseDown: (e)=>{
            handleClose(e);
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("wrap-modal-content", contentClassName),
            onMouseDown: (e)=>{
                // var target = getSelectedElementFromPoint(e.clientX, e.clientY);
                e.stopPropagation();
                return;
            },
            onClick: (e)=>e.stopPropagation(),
            children: [
                header ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("modal-header", headerClassName),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: header
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            onClick: handleClose,
                            className: "cursor-pointer text-fs-24 text-grey-800",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: "mrv mrv-close"
                            })
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("modal-body", bodyClassName),
                    children: children
                }),
                footer ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("modal-footer", footerClassName),
                    children: footer
                }) : null
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Modal);


/***/ }),

/***/ 98907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _cyntler_react_doc_viewer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2493);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);
// const   = dynamic(import("@cyntler/react-doc-viewer"), { ssr: false });



const DocViewerPreview = (param)=>{
    let { url , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cyntler_react_doc_viewer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("h-full", className),
            pluginRenderers: _cyntler_react_doc_viewer__WEBPACK_IMPORTED_MODULE_1__/* .DocViewerRenderers */ .lX,
            documents: [
                {
                    uri: url
                }
            ],
            config: {
                header: {
                    disableHeader: true
                }
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (DocViewerPreview);


/***/ }),

/***/ 54370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _constants_common_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17785);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);




const ReviewShowTextContent = (param)=>{
    let { className , content , mentions , limit , searchString  } = param;
    const htmlContent = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        let rawContentString = content;
        mentions === null || mentions === void 0 ? void 0 : mentions.forEach((mention)=>{
            rawContentString = rawContentString.replaceAll("@{{".concat(mention.userId, "||").concat(mention.nickName, "}}"), "@".concat(mention.nickName)).replaceAll("@{{".concat(mention.userId, "||anymos}}"), "@Ẩn danh");
        });
        if ((limit || rawContentString.length <= limit) && !searchString) {
            const needReplaceItems = [];
            let lastedIndexFind = 0;
            let lastedIndexRawFind = 0;
            mentions === null || mentions === void 0 ? void 0 : mentions.forEach((mention)=>{
                const oldData = mention.nickName ? "@{{".concat(mention.userId, "||").concat(mention.nickName, "}}") : "@{{".concat(mention.userId, "||anymos}}");
                const replaceData = "@".concat(mention.nickName ? mention.nickName : "Ẩn danh");
                // const regex = new RegExp()
                const indexFind = content.indexOf(oldData, lastedIndexFind);
                const indexRawFind = rawContentString.indexOf(replaceData, lastedIndexRawFind);
                if (indexFind >= 0) {
                    needReplaceItems.push({
                        index: indexFind,
                        rootData: oldData,
                        indexInRawData: indexRawFind,
                        showRawData: replaceData,
                        replaceData: function() {
                            let len = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                            return '<span class="text-blue-500 cursor-pointer">'.concat(len ? replaceData.slice(0, len) : replaceData, " </span>");
                        }
                    });
                    lastedIndexFind = indexFind;
                    lastedIndexRawFind = indexRawFind + 1;
                }
            });
            let match;
            let lastedIndexRawFindLink = 0;
            while(match = _constants_common_constant__WEBPACK_IMPORTED_MODULE_1__/* .urlRegex.exec */ .yV.exec(content)){
                const indexLink = match.index;
                const link = match[0];
                const indexRawFindLink = rawContentString.indexOf(link, lastedIndexRawFindLink);
                needReplaceItems.push({
                    index: indexLink,
                    rootData: link,
                    showRawData: link,
                    indexInRawData: indexRawFindLink,
                    replaceData: function() {
                        let len = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                        return '<a href="'.concat(link, '" title="').concat(link, '" class="w-auto break-all" target="_blank">').concat(len ? link.slice(0, len) : link, "</a>");
                    }
                });
                lastedIndexRawFindLink = indexRawFindLink + 1;
            }
            needReplaceItems.sort((a, b)=>a.indexInRawData - b.indexInRawData);
            let returnString = "";
            let currentLen = returnString.length;
            if (needReplaceItems.length) {
                for(let id = 0; id < needReplaceItems.length; id++){
                    const item = needReplaceItems[id];
                    // console.log(needReplaceItems, item.indexInRawData);
                    if (currentLen < limit) if (item.indexInRawData <= limit) {
                        if (item.showRawData.length + item.indexInRawData >= limit) {
                            const concatString = content.slice(id === 0 ? 0 : needReplaceItems[id - 1].index + needReplaceItems[id - 1].rootData.length, item.index) + item.replaceData(limit - item.indexInRawData);
                            returnString += concatString;
                            currentLen += limit - (id === 0 ? 0 : needReplaceItems[id - 1].indexInRawData + needReplaceItems[id - 1].showRawData.length);
                        } else {
                            const concatString1 = content.slice(id === 0 ? 0 : needReplaceItems[id - 1].index + needReplaceItems[id - 1].rootData.length, item.index) + item.replaceData();
                            returnString += concatString1;
                            currentLen += item.indexInRawData - (id === 0 ? 0 : needReplaceItems[id - 1].indexInRawData + needReplaceItems[id - 1].showRawData.length) + item.showRawData.length;
                        }
                    } else {
                        const concatString2 = content.slice(id === 0 ? 0 : needReplaceItems[id - 1].index + needReplaceItems[id - 1].rootData.length, limit - currentLen);
                        returnString += concatString2;
                        currentLen += limit - currentLen - (id === 0 ? 0 : needReplaceItems[id - 1].indexInRawData + needReplaceItems[id - 1].showRawData.length);
                    }
                }
                if (currentLen < limit) {
                    const lastedItem = needReplaceItems[needReplaceItems.length - 1];
                    returnString += content.slice(lastedItem.index + lastedItem.rootData.length, limit - currentLen + lastedItem.index + lastedItem.rootData.length);
                }
            } else returnString = content.slice(0, limit);
            return returnString;
        } else {
            let contentString = content;
            const searchRegex = new RegExp(searchString, "ig");
            if (searchString) {
                contentString = contentString.replaceAll(searchRegex, (substring, index, data)=>{
                    const listLink = contentString.match(_constants_common_constant__WEBPACK_IMPORTED_MODULE_1__/* .urlRegex */ .yV);
                    let mark = false;
                    mentions.forEach((mention)=>{
                        const mentionString = mention.nickName ? "@{{".concat(mention.userId, "||").concat(mention.nickName, "}}") : "@{{".concat(mention.userId, "||anymos}}");
                        let startIndexFind = -1;
                        do {
                            const find = contentString.indexOf(mentionString, startIndexFind + 1);
                            if (find > -1) {
                                if (find <= index && index < find + mentionString.length) mark = true;
                                startIndexFind = find + mentionString.length;
                            } else startIndexFind = find;
                        // debugger;
                        }while (startIndexFind >= 0);
                    });
                    if (mark) return substring;
                    return (listLink === null || listLink === void 0 ? void 0 : listLink.find((e)=>e.indexOf(substring) >= 0)) ? substring : '<span class="bg-[rgba(255,198,51,0.30)] cursor-pointer">'.concat(substring, "</span>");
                });
            }
            mentions === null || mentions === void 0 ? void 0 : mentions.forEach((mention)=>{
                rawContentString = rawContentString.replaceAll("@{{".concat(mention.userId, "||").concat(mention.nickName, "}}"), "".concat(mention.nickName)).replaceAll("@{{".concat(mention.userId, "||anymos}}"), "@Ẩn danh");
                contentString = contentString.replaceAll("@{{".concat(mention.userId, "||").concat(mention.nickName, "}}"), '<span class="text-blue-500 cursor-pointer">@'.concat(mention.nickName, " </span>")).replaceAll("@{{".concat(mention.userId, "||anymos}}"), '<span class="text-blue-500 cursor-pointer">@Ẩn danh </span>');
            });
            // handle link
            contentString = contentString.replace(_constants_common_constant__WEBPACK_IMPORTED_MODULE_1__/* .urlRegex */ .yV, function(url) {
                return '<a href="'.concat(url, '" title="').concat(url, '" class="w-auto break-all" target="_blank">').concat(url.replaceAll(searchRegex, (substring)=>'<span class="bg-[rgba(255,198,51,0.30)] cursor-pointer">'.concat(substring, "</span>")), "</a>");
            });
            return contentString;
        }
    }, [
        content,
        limit,
        mentions,
        searchString
    ]);
    const [mounted, setMounted] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setMounted(true);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("whitespace-pre-wrap", className),
        dangerouslySetInnerHTML: {
            __html: mounted ? htmlContent : content
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReviewShowTextContent);


/***/ }),

/***/ 70731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Share; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/constants/environment.ts
var environment = __webpack_require__(7181);
// EXTERNAL MODULE: ./src/context/device.context.tsx
var device_context = __webpack_require__(99757);
// EXTERNAL MODULE: ./src/constants/image.ts
var constants_image = __webpack_require__(24435);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 6 modules
var tooltip = __webpack_require__(62062);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Share/CopyLink.tsx




const CopyLink = (param)=>{
    let { url  } = param;
    const [isShowTooltip, setShowTooltip] = (0,react.useState)(false);
    const isClient = "object" !== "undefined";
    const onCopy = ()=>{
        if (isClient && navigator.clipboard) {
            navigator.clipboard.writeText(url).then(()=>{
                setTimeout(()=>setShowTooltip(false), 1500);
                setShowTooltip(true);
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
            title: "Đ\xe3 sao ch\xe9p",
            open: isShowTooltip,
            arrow: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center p-3 rounded-lg cursor-pointer duration-300 hover:bg-grey-50",
                onClick: onCopy,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: constants_image/* CopyIcon */.TI,
                        alt: "CopyIcon"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-3 text-fs-14 text-grey-800 font-medium",
                        children: "Sao ch\xe9p li\xean kết"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Share_CopyLink = (CopyLink);

// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__(16573);
;// CONCATENATED MODULE: ./src/components/Share/ShareFacebook.tsx




const ShareFacebook = (param)=>{
    let { url  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton/* default */.Z, {
            url: url,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center p-3 rounded-lg cursor-pointer duration-300 hover:bg-grey-50",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: constants_image/* FacebookIcon */.Vq,
                        alt: "FacebookIcon"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-3 text-fs-14 text-grey-800 font-medium",
                        children: "Chia sẻ l\xean Facebook"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Share_ShareFacebook = (ShareFacebook);

// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookMessengerShareButton.js
var FacebookMessengerShareButton = __webpack_require__(89674);
;// CONCATENATED MODULE: ./src/components/Share/ShareMessenger.tsx




const ShareMessenger = (param)=>{
    let { url , appId  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookMessengerShareButton/* default */.Z, {
            appId: appId,
            url: url,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center p-3 rounded-lg cursor-pointer duration-300 hover:bg-grey-50",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: constants_image/* MessengerIcon */.qA,
                        alt: "Share Messenger"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-3 text-fs-14 text-grey-800 font-medium",
                        children: "Chia sẻ l\xean Messenger"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Share_ShareMessenger = (ShareMessenger);

// EXTERNAL MODULE: ./node_modules/react-share/es/TelegramShareButton.js
var TelegramShareButton = __webpack_require__(38168);
;// CONCATENATED MODULE: ./src/components/Share/ShareTeleGram.tsx




const ShareTeleGram = (param)=>{
    let { url  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TelegramShareButton/* default */.Z, {
            url: url,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center p-3 rounded-lg cursor-pointer duration-300 hover:bg-grey-50",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: constants_image/* TelegramIcon */.YG,
                        alt: "TelegramIcon"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-3 text-fs-14 text-grey-800 font-medium",
                        children: "Chia sẻ l\xean Telegram"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Share_ShareTeleGram = (ShareTeleGram);

// EXTERNAL MODULE: ./node_modules/react-share/es/WhatsappShareButton.js
var WhatsappShareButton = __webpack_require__(12834);
;// CONCATENATED MODULE: ./src/components/Share/ShareWhatApp.tsx




const shareWhatApp = (param)=>{
    let { url  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsappShareButton/* default */.Z, {
            url: url,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center p-3 rounded-lg cursor-pointer duration-300 hover:bg-grey-50",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: constants_image/* WhatsAppIcon */.yB,
                        alt: "WhatsAppIcon"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-3 text-fs-14 text-grey-800 font-medium",
                        children: "Chia sẻ l\xean WhatsApp"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var ShareWhatApp = (shareWhatApp);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./src/components/Share/ShareZalo.tsx





const DEFAULT_IFRAME_HEIGHT = 352;
let timeOutOpenShare = null;
const ShareZalo = (param)=>{
    let { url , isHideText =false , className ="" , visible  } = param;
    const [shareZaloDestop, setShareZaloDesktop] = (0,react.useState)(false);
    const [heightIframe, setHeightIframe] = (0,react.useState)(DEFAULT_IFRAME_HEIGHT);
    const zaloIframe = (0,react.useRef)(null);
    const buttonZalo = (0,react.useRef)(null);
    const getLinkEncodeZalo = (0,react.useMemo)(()=>{
        return btoa(JSON.stringify({
            url: url
        }));
    }, [
        url
    ]);
    const onMessangePostEvent = (0,react.useCallback)((e)=>{
        var _e_data;
        switch(e === null || e === void 0 ? void 0 : (_e_data = e.data) === null || _e_data === void 0 ? void 0 : _e_data.cmd){
            case "zsdk_close_share":
                zaloIframe.current.style.zIndex = "-1";
                zaloIframe.current.style.display = "none";
                window.removeEventListener("message", onMessangePostEvent);
                break;
            case "zsdk_open_share":
                setHeightIframe(DEFAULT_IFRAME_HEIGHT);
                clearTimeout(timeOutOpenShare);
                break;
            case "zsdk_share_resize":
                {
                    setHeightIframe(DEFAULT_IFRAME_HEIGHT + e.data.height);
                    break;
                }
            default:
                {
                    break;
                }
        }
    }, []);
    const linkToZalo = (0,react.useCallback)(()=>{
        if (!lib/* isMobile */.tq && !lib/* isTablet */.Em) {
            setShareZaloDesktop(true);
            zaloIframe.current.style.zIndex = "9";
            zaloIframe.current.style.display = "block";
            const buttonBoundingTop = buttonZalo.current.getBoundingClientRect().top;
            const windowHeight = window.innerHeight;
            const buttonOffsetBottom = windowHeight - buttonBoundingTop;
            if (buttonOffsetBottom < 360) {
                zaloIframe.current.style.top = "-350px";
            }
            zaloIframe.current.contentWindow.postMessage({
                type: "clickOpenShare"
            }, "*");
            window.addEventListener("message", onMessangePostEvent);
            timeOutOpenShare = setTimeout(()=>{
                zaloIframe.current.style.zIndex = "-1";
                zaloIframe.current.style.display = "none";
                window.removeEventListener("message", onMessangePostEvent);
            }, 500);
            return;
        }
        if (lib/* isIOS */.gn) {
            location.href = "zaloshareext://shareext?url=".concat(encodeURIComponent(url), "&type=8&version=1");
            return;
        }
        location.href = "intent://zaloapp.com/#Intent;action=android.intent.action.SEND;type=text/plain;S.android.intent.extra.SUBJECT=;S.android.intent.extra.TEXT=".concat(encodeURIComponent(url), ";B.hidePostFeed=false;B.backToSource=true;end");
    }, [
        onMessangePostEvent,
        url
    ]);
    (0,react.useEffect)(()=>{
        if (!visible) {
            zaloIframe.current.style.zIndex = "-1";
            zaloIframe.current.style.display = "none";
        }
    }, [
        visible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center p-3 rounded-lg cursor-pointer  duration-300 hover:bg-grey-50 relative ".concat(className),
        onClick: linkToZalo,
        ref: buttonZalo,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: constants_image/* ZaloIcon */.Af,
                className: "w-6 h-6",
                alt: "zalo icon",
                width: "24px",
                height: "24px"
            }),
            !isHideText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "ml-3 text-fs-14 text-grey-800 font-medium",
                children: "Chia sẻ Zalo"
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                title: "zalo sdk",
                ref: zaloIframe,
                height: heightIframe,
                className: (0,clsx_m/* default */.Z)("absolute -z-10 right-0 top-10 w-[30rem]", !lib/* isMobile */.tq && !lib/* isTablet */.Em && shareZaloDestop ? "block" : "hidden"),
                scrolling: "no",
                frameBorder: "0",
                src: "https://button-share.zalo.me/share_inline?layout=2&color=blue&customize=true&width=0px&height=0px&isDesktop=true&d=".concat(getLinkEncodeZalo)
            })
        ]
    });
};
/* harmony default export */ var Share_ShareZalo = (ShareZalo);

// EXTERNAL MODULE: ./node_modules/antd/es/popover/index.js + 3 modules
var popover = __webpack_require__(74627);
// EXTERNAL MODULE: ./node_modules/antd/es/drawer/index.js + 9 modules
var drawer = __webpack_require__(85265);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js + 14 modules
var es_button = __webpack_require__(89779);
;// CONCATENATED MODULE: ./src/components/Share/index.tsx











const ShareButton = (param)=>{
    let { children , shareUrl  } = param;
    const { isMobile  } = (0,react.useContext)(device_context/* DeviceContext */.T);
    const [isShowOther, setShowOther] = (0,react.useState)(false);
    const [isOpenDrawer, setOpenDrawer] = (0,react.useState)(false);
    // useEffect(() => {
    //   if (isOpenDrawer) document.body.style.overflow = "hidden";
    //   else document.body.style.overflow = "auto";
    // }, [isOpenDrawer]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* default */.Z, {
            destroyTooltipOnHide: true,
            onOpenChange: ()=>setShowOther(false),
            showArrow: true,
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Share_ShareFacebook, {
                        url: shareUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Share_ShareZalo, {
                        url: shareUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Share_CopyLink, {
                        url: shareUrl
                    }),
                    isShowOther ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Share_ShareMessenger, {
                                url: shareUrl,
                                appId: environment/* MESSENGER_APPID */.vp
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareWhatApp, {
                                url: shareUrl
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Share_ShareTeleGram, {
                                url: shareUrl
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex md:justify-center items-center cursor-pointer p-3 md:p-0 hover:bg-grey-50",
                        onClick: ()=>{
                            setShowOther(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "mrv mrv-keyboard_arrow_down md:text-fs-20 text-fs-24 text-grey-800 rounded-[24px] bg-grey-50 md:bg-transparent"
                        })
                    })
                ]
            }),
            trigger: [
                "click"
            ],
            placement: "bottomLeft",
            overlayClassName: "z-[10]",
            children: children
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    onClick: ()=>{
                        document.body.style.overflow = "hidden";
                        setOpenDrawer(true);
                    },
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(drawer/* default */.Z, {
                    placement: "bottom",
                    open: isOpenDrawer,
                    className: "rounded-t-3xl",
                    title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full flex flex-row justify-between items-center right-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                                className: "bg-transparent shadow-none border-0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex text-center",
                                children: "Chia sẻ"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                                className: "flex border-0 bg-transparent shadow-none items-center order-last",
                                onClick: ()=>{
                                    setOpenDrawer(false);
                                    document.body.style.overflow = "auto";
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "mrv mrv-close text-fs-24 flex justify-center text-center items-center"
                                })
                            })
                        ]
                    }),
                    headerStyle: {
                        background: "#EBF3FC",
                        padding: "0.5rem"
                    },
                    closeIcon: null,
                    height: "auto",
                    maskClosable: true,
                    onClose: ()=>{
                        setOpenDrawer(false);
                        setShowOther(false);
                        document.body.style.overflow = "auto";
                    },
                    destroyOnClose: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Share_ShareFacebook, {
                                url: shareUrl
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Share_ShareZalo, {
                                url: shareUrl
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Share_CopyLink, {
                                url: shareUrl
                            }),
                            isShowOther ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Share_ShareMessenger, {
                                        url: shareUrl,
                                        appId: environment/* MESSENGER_APPID */.vp
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareWhatApp, {
                                        url: shareUrl
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Share_ShareTeleGram, {
                                        url: shareUrl
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full flex md:justify-center items-center cursor-pointer p-3 md:p-0 hover:bg-grey-50",
                                onClick: ()=>{
                                    setShowOther(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "mrv mrv-keyboard_arrow_down md:text-fs-20 text-fs-24 text-grey-800 rounded-full bg-grey-50 md:bg-transparent"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-fs-14 text-grey-800 font-medium ml-3",
                                        children: "Xem th\xeam lựa chọn"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Share = (ShareButton);


/***/ }),

/***/ 44352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ CommentTypeEnum; }
/* harmony export */ });
/* unused harmony export ReactionType */
var CommentTypeEnum;
(function(CommentTypeEnum) {
    CommentTypeEnum[CommentTypeEnum["REVIEW"] = 1] = "REVIEW";
    CommentTypeEnum[CommentTypeEnum["QUESTION"] = 2] = "QUESTION";
    CommentTypeEnum[CommentTypeEnum["REPLY"] = 3] = "REPLY";
})(CommentTypeEnum || (CommentTypeEnum = {}));
var ReactionType;
(function(ReactionType) {
    ReactionType[ReactionType["LIKE"] = 1] = "LIKE";
    ReactionType[ReactionType["DISLIKE"] = 2] = "DISLIKE";
})(ReactionType || (ReactionType = {}));


/***/ }),

/***/ 1303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useAnimateState; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useAnimateState = (param)=>{
    let { open , handleClose  } = param;
    const [trigger, setTrigger] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (open) setTimeout(()=>{
            setTrigger(true);
        }, 100);
    }, [
        open
    ]);
    const triggerClose = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        setTrigger(false);
        setTimeout(()=>{
            handleClose && handleClose();
        }, 300);
    }, [
        handleClose
    ]);
    return {
        trigger,
        triggerClose
    };
};


/***/ }),

/***/ 25256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_MeeyImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3524);
/* harmony import */ var _components_ReviewInputComponent_tsx_DocViewerPreview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98907);
/* harmony import */ var _constants_file__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32336);
/* harmony import */ var _context_project_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12482);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67650);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26126);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40364);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _components_VideoPlayer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19534);
/* harmony import */ var _constants_enum_media__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71381);
/* harmony import */ var _hooks_useAnimateState__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1303);














const ModalViewDetailFile = ()=>{
    var _selectedViewFiles_currentFile;
    const { selectedViewFiles , setSelectedViewFiles  } = (0,react__WEBPACK_IMPORTED_MODULE_6__.useContext)(_context_project_context__WEBPACK_IMPORTED_MODULE_4__/* .ProjectContext */ .x);
    const [mounted, setMounted] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [currentRotate, setCurrentRotate] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        setMounted(true);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        if (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile) {
            document.body.style.overflow = "hidden";
        } else document.body.style.overflow = "auto";
        return ()=>{
            document.body.style.overflow = "auto";
        };
    }, [
        selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile
    ]);
    const currentIndexFile = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(()=>{
        return selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files.findIndex((item)=>{
            var _selectedViewFiles_currentFile;
            return item._id == (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile === void 0 ? void 0 : _selectedViewFiles_currentFile._id);
        });
    }, [
        selectedViewFiles
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        const mediaWrapper = document.getElementById("media-wrapper");
        if (mediaWrapper) {
            mediaWrapper.scrollTo({
                left: currentIndexFile * 72 + currentIndexFile * 8,
                behavior: "smooth"
            });
        }
    }, [
        currentIndexFile,
        selectedViewFiles,
        mounted
    ]);
    const { trigger , triggerClose  } = (0,_hooks_useAnimateState__WEBPACK_IMPORTED_MODULE_12__/* .useAnimateState */ .T)({
        open: !!(selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile),
        handleClose: ()=>{
            return setSelectedViewFiles({
                currentFile: null,
                files: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files
            });
        }
    });
    return mounted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("fixed duration-300 top-0 z-40 left-0 w-screen h-screen bg-black-1000  overflow-hidden  custom-modal-preview-file flex flex-col flex-[1_auto_1] gap-2 p-4", trigger ? "opacity-100" : "opacity-0"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_7__/* .TransformWrapper */ .d$, {
                initialScale: 1,
                disabled: (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile === void 0 ? void 0 : _selectedViewFiles_currentFile.mediaType) != _constants_enum_media__WEBPACK_IMPORTED_MODULE_11__/* .MediaTypeEnum.IMAGE.toString */ .L.IMAGE.toString(),
                children: (param)=>{
                    let { zoomIn , zoomOut , resetTransform , ...rest } = param;
                    var _selectedViewFiles_currentFile, _selectedViewFiles_currentFile1, _selectedViewFiles_currentFile2, _selectedViewFiles_currentFile3, _selectedViewFiles_currentFile4, _selectedViewFiles_currentFile5, _selectedViewFiles_currentFile6, _selectedViewFiles_files, _selectedViewFiles_files1;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
                        children: [
                            " ",
                            (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center justify-center relative w-full h-9",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "mrv mrv-close text-white text-fs-32 leading-[2rem] cursor-pointer absolute left-0",
                                                onClick: triggerClose
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("rounded-[18px] items-center gap-2 h-9 bg-grey-100", (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile === void 0 ? void 0 : _selectedViewFiles_currentFile.mediaType) == _constants_enum_media__WEBPACK_IMPORTED_MODULE_11__/* .MediaTypeEnum.IMAGE.toString */ .L.IMAGE.toString() ? "flex" : "hidden"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                        onClick: ()=>zoomIn(),
                                                        className: "px-3 py-2",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                            className: "mrv mrv-zoom_in text-fs-20 text-grey-700"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                        onClick: ()=>zoomOut(),
                                                        className: "px-3 py-2",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                            className: "mrv mrv-zoom_out text-fs-20 text-grey-700"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile1 = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile1 === void 0 ? void 0 : _selectedViewFiles_currentFile1.url,
                                                        download: true,
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                            className: "px-3 py-2",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "mrv mrv-download text-fs-20 text-grey-700"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                        className: "px-3 py-2",
                                                        onClick: ()=>{
                                                            if (currentRotate == 180) {
                                                                setCurrentRotate(-90);
                                                            } else {
                                                                setCurrentRotate(currentRotate + 90);
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                            className: "mrv mrv-rotate_90_degrees_cw text-fs-20 text-grey-700"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                        className: "px-3 py-2",
                                                        onClick: ()=>{
                                                            if (currentRotate == -90) {
                                                                setCurrentRotate(180);
                                                            } else {
                                                                setCurrentRotate(currentRotate - 90);
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                            className: "mrv mrv-rotate_90_degrees_ccw text-fs-20 text-grey-700"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_9___default()), {
                                                href: "/review/".concat(selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile2 = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile2 === void 0 ? void 0 : _selectedViewFiles_currentFile2.comment),
                                                target: "_blank",
                                                className: "absolute right-0",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                    className: "meey-button meey-button-grey meey-button-filled rounded-[18px] text-fs-14 font-medium px-3 h-9 flex gap-1 justify-center items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: "Xem b\xe0i review"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                            className: "mrv mrv-open_in_new text-fs-18"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "h-[80vh] w-full flex justify-between items-center gap-6",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                onClick: ()=>{
                                                    if (currentIndexFile != 0) {
                                                        resetTransform();
                                                        setSelectedViewFiles({
                                                            ...selectedViewFiles,
                                                            currentFile: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files[currentIndexFile - 1]
                                                        });
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("mrv mrv-chevron_left  text-fs-32 leading-[32px]", currentIndexFile == 0 ? "cursor-not-allowed text-grey-100" : "text-white")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-full h-full",
                                                children: (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile3 = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile3 === void 0 ? void 0 : _selectedViewFiles_currentFile3.mediaType) == _constants_enum_media__WEBPACK_IMPORTED_MODULE_11__/* .MediaTypeEnum.IMAGE.toString */ .L.IMAGE.toString() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_7__/* .TransformComponent */ .Uv, {
                                                    contentClass: "!h-full !w-full flex justify-between items-center",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "w-full h-full flex justify-center",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: selectedViewFiles.currentFile.uri.match(_constants_file__WEBPACK_IMPORTED_MODULE_3__/* .fileType.resizeImageSupport */ .r.resizeImageSupport) ? (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .resizeOnFlyUrl */ .Li)({
                                                                uri: selectedViewFiles.currentFile.uri,
                                                                width: 0,
                                                                height: 0,
                                                                gravity: "ce",
                                                                resizingType: "auto"
                                                            }) : selectedViewFiles.currentFile.url,
                                                            alt: "test",
                                                            className: "w-[inherit] h-full absolute object-contain",
                                                            style: {
                                                                transform: "rotate(".concat(currentRotate, "deg)")
                                                            }
                                                        }, currentRotate)
                                                    })
                                                }) : (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile4 = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile4 === void 0 ? void 0 : _selectedViewFiles_currentFile4.mediaType) == _constants_enum_media__WEBPACK_IMPORTED_MODULE_11__/* .MediaTypeEnum.VIDEO.toString */ .L.VIDEO.toString() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_7__/* .TransformComponent */ .Uv, {
                                                    contentClass: "!h-full !w-full flex justify-between items-center",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_VideoPlayer__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                        options: {
                                                            autoplay: true,
                                                            muted: true,
                                                            controls: true,
                                                            responsive: true,
                                                            fluid: true,
                                                            sources: [
                                                                {
                                                                    src: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.urlVod
                                                                }
                                                            ]
                                                        }
                                                    }, selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile5 = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile5 === void 0 ? void 0 : _selectedViewFiles_currentFile5.urlVod)
                                                }) : (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.name.match(_constants_file__WEBPACK_IMPORTED_MODULE_3__/* .fileType.viewFileSupport */ .r.viewFileSupport)) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_7__/* .TransformComponent */ .Uv, {
                                                    contentClass: "!h-full !w-full flex justify-between items-center",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ReviewInputComponent_tsx_DocViewerPreview__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                                        url: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.url
                                                    })
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_7__/* .TransformComponent */ .Uv, {
                                                    contentClass: "!h-full !w-full flex justify-center items-center",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "w-[685px] h-[196px] rounded-xl p-6 flex flex-col justify-center gap-4 bg-grey-100",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "flex items-center gap-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                        className: "mrv mrv-docs text-fs-36 text-grey-700"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "flex flex-col text-grey-700",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                className: "text-base font-medium text-grey-800 line-clamp-1 break-words w-full",
                                                                                title: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.name,
                                                                                children: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.name
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                className: "text-fs-12",
                                                                                children: [
                                                                                    (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.size) / 1000,
                                                                                    " ",
                                                                                    "MB"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "text-fs-20 text-grey-800 font-semibold",
                                                                children: "Kh\xf4ng thể xem trước tệp n\xe0y. Vui l\xf2ng tải xuống để xem nội dung"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile6 = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile6 === void 0 ? void 0 : _selectedViewFiles_currentFile6.url,
                                                                download: true,
                                                                target: "_blank",
                                                                className: "flex justify-center w-full",
                                                                rel: "noreferrer",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                                    className: "meey-button meey-button-primary meey-button-filled py-2.5 px-4 h-11 flex items-center gap-1 w-fit ",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                            className: "mrv mrv-download text-fs-20"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "text-fs-16 font-semibold",
                                                                            children: "Tải xuống"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                onClick: ()=>{
                                                    var _selectedViewFiles_files;
                                                    if (currentIndexFile < (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_files = selectedViewFiles.files) === null || _selectedViewFiles_files === void 0 ? void 0 : _selectedViewFiles_files.length) - 1) {
                                                        resetTransform();
                                                        setSelectedViewFiles({
                                                            ...selectedViewFiles,
                                                            currentFile: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files[currentIndexFile + 1]
                                                        });
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("mrv mrv-chevron_right  text-fs-32 leading-[32px]", currentIndexFile == (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_files = selectedViewFiles.files) === null || _selectedViewFiles_files === void 0 ? void 0 : _selectedViewFiles_files.length) - 1 ? "cursor-not-allowed text-grey-100" : "text-white")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: " p-2 rounded-lg text-fs-12 text-grey-600 flex overflow-auto gap-2 flex-[0_0_auto] max-w-[848px] mx-auto",
                                id: "media-wrapper",
                                children: (selectedViewFiles.maxFileShow ? selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_files1 = selectedViewFiles.files) === null || _selectedViewFiles_files1 === void 0 ? void 0 : _selectedViewFiles_files1.slice(currentIndexFile, currentIndexFile + selectedViewFiles.maxFileShow) : selectedViewFiles.files).map((file)=>{
                                    var _selectedViewFiles_currentFile, _file_name_split;
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("relative group cursor-pointer h-fit flex-0 rounded-lg duration-300 border-2", file.mediaType == _constants_enum_media__WEBPACK_IMPORTED_MODULE_11__/* .MediaTypeEnum.IMAGE.toString */ .L.IMAGE.toString() || file.mediaType == _constants_enum_media__WEBPACK_IMPORTED_MODULE_11__/* .MediaTypeEnum.VIDEO.toString */ .L.VIDEO.toString() ? "can-preview-upload" : "default-file", file.s3Key === ((_selectedViewFiles_currentFile = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile === void 0 ? void 0 : _selectedViewFiles_currentFile.s3Key) ? " !border-blue-500" : ""),
                                        children: [
                                            file.mediaType == _constants_enum_media__WEBPACK_IMPORTED_MODULE_11__/* .MediaTypeEnum.IMAGE.toString */ .L.IMAGE.toString() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-[4.5rem] h-[4.5rem] bg-grey-200 rounded-md flex flex-col relative cursor-pointer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: " text-fs-12 w-full h-full overflow-hidden rounded-md",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MeeyImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                        className: "object-cover w-full h-full",
                                                        src: file.uri,
                                                        alt: file.name,
                                                        resizeOnFly: !!(file === null || file === void 0 ? void 0 : file.uri),
                                                        resizeOptions: {
                                                            width: 72,
                                                            height: 72
                                                        }
                                                    })
                                                })
                                            }) : file.mediaType == _constants_enum_media__WEBPACK_IMPORTED_MODULE_11__/* .MediaTypeEnum.VIDEO.toString */ .L.VIDEO.toString() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-[4.5rem] h-[4.5rem] bg-grey-200 rounded-md flex flex-col relative cursor-pointer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: " text-fs-12 w-full h-full overflow-hidden rounded-b-md",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_VideoPlayer__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                            options: {
                                                                autoplay: false,
                                                                muted: true,
                                                                controls: false,
                                                                responsive: true,
                                                                preload: "metadata",
                                                                fluid: true,
                                                                sources: [
                                                                    {
                                                                        src: file.urlVod
                                                                    }
                                                                ]
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "mrv mrv-play_arrow text-white text-fs-24 font-bold"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "w-[4.5rem] h-[4.5rem] bg-grey-200 rounded-md flex flex-col relative cursor-pointer border border-transparent border-dashed",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex-[0_0_36px] w-full flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "-rotate-90 w-fit mr-2",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                    className: "mrv mrv-attachment text-fs-20 "
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                children: [
                                                                    ".",
                                                                    (_file_name_split = file.name.split(".")) === null || _file_name_split === void 0 ? void 0 : _file_name_split.pop()
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "bg-grey-300 flex-[1_1_auto] text-fs-12 py-1 px-2 overflow-hidden rounded-b-md",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "line-clamp-2",
                                                            children: file.name
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                onClick: ()=>{
                                                    resetTransform();
                                                    setSelectedViewFiles({
                                                        ...selectedViewFiles,
                                                        currentFile: file
                                                    });
                                                },
                                                className: "cursor-pointer absolute w-full h-full top-0 z-30 bg-[rgba(0,0,0,0.4)] flex items-center justify-center opacity-0 group-hover:opacity-100 rounded-md duration-300",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                    className: "mrv mrv-preview text-white text-fs-20"
                                                })
                                            })
                                        ]
                                    }, file.s3Key);
                                })
                            })
                        ]
                    });
                }
            })
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalViewDetailFile);


/***/ }),

/***/ 19826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_MeeyImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3524);
/* harmony import */ var _components_ReviewInputComponent_tsx_DocViewerPreview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98907);
/* harmony import */ var _constants_file__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32336);
/* harmony import */ var _context_project_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12482);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67650);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26126);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40364);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _components_VideoPlayer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19534);
/* harmony import */ var _constants_enum_media__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71381);
/* harmony import */ var _hooks_useAnimateState__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1303);














const ModalViewDetailFile = (param)=>{
    let { openModal , handleClose  } = param;
    var _selectedViewFiles_currentFile;
    const { selectedViewFiles , setSelectedViewFiles  } = (0,react__WEBPACK_IMPORTED_MODULE_6__.useContext)(_context_project_context__WEBPACK_IMPORTED_MODULE_4__/* .ProjectContext */ .x);
    const [mounted, setMounted] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [currentRotate, setCurrentRotate] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        setMounted(true);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        if (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile) {
            document.body.style.overflow = "hidden";
        } else document.body.style.overflow = "auto";
        return ()=>{
            document.body.style.overflow = "auto";
        };
    }, [
        selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile
    ]);
    const currentIndexFile = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(()=>{
        return selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files.findIndex((item)=>{
            var _selectedViewFiles_currentFile;
            return item._id == (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile === void 0 ? void 0 : _selectedViewFiles_currentFile._id);
        });
    }, [
        selectedViewFiles
    ]);
    const { trigger , triggerClose  } = (0,_hooks_useAnimateState__WEBPACK_IMPORTED_MODULE_12__/* .useAnimateState */ .T)({
        open: !!(selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile),
        handleClose: ()=>{
            return setSelectedViewFiles({
                currentFile: null,
                files: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files
            });
        }
    });
    const itemsRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)([]);
    const parentListRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)();
    return mounted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("duration-300 fixed top-0 z-40 left-0 w-screen h-screen bg-black-1000  overflow-hidden custom-modal-preview-file flex flex-col flex-[1_auto_1] gap-2 p-4", trigger ? "opacity-100" : "opacity-0"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_7__/* .TransformWrapper */ .d$, {
                initialScale: 1,
                disabled: (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile === void 0 ? void 0 : _selectedViewFiles_currentFile.mediaType) != _constants_enum_media__WEBPACK_IMPORTED_MODULE_11__/* .MediaTypeEnum.IMAGE.toString */ .L.IMAGE.toString(),
                children: (param)=>{
                    let { zoomIn , zoomOut , resetTransform , ...rest } = param;
                    var _selectedViewFiles_currentFile, _selectedViewFiles_currentFile1, _selectedViewFiles_currentFile2, _selectedViewFiles_files, _selectedViewFiles_currentFile3, _selectedViewFiles_currentFile4, _selectedViewFiles_currentFile5, _selectedViewFiles_currentFile6, _selectedViewFiles_files1;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "mrv mrv-close text-white text-fs-32 leading-[2rem] cursor-pointer",
                                        onClick: triggerClose
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_9___default()), {
                                        href: "/review/".concat(selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile === void 0 ? void 0 : _selectedViewFiles_currentFile.comment),
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            className: "meey-button meey-button-grey meey-button-filled rounded-[18px] text-fs-14 font-medium px-3 h-9 flex gap-1 justify-center items-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    children: "Xem b\xe0i review"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                    className: "mrv mrv-open_in_new text-fs-18"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: ()=>{
                                            if (currentIndexFile != 0) {
                                                resetTransform();
                                                setSelectedViewFiles({
                                                    ...selectedViewFiles,
                                                    currentFile: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files[currentIndexFile - 1]
                                                });
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("mrv mrv-chevron_left  text-fs-32 leading-[32px]", currentIndexFile == 0 ? "cursor-not-allowed text-grey-100" : "text-white")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("rounded-[18px] justify-center w-fit mx-auto items-center gap-2 h-9 bg-grey-100", (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile1 = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile1 === void 0 ? void 0 : _selectedViewFiles_currentFile1.mediaType) == _constants_enum_media__WEBPACK_IMPORTED_MODULE_11__/* .MediaTypeEnum.IMAGE.toString */ .L.IMAGE.toString() ? "flex" : "hidden"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                onClick: ()=>zoomIn(),
                                                className: "px-3 py-2",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                    className: "mrv mrv-zoom_in text-fs-20 text-grey-700"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                onClick: ()=>zoomOut(),
                                                className: "px-3 py-2",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                    className: "mrv mrv-zoom_out text-fs-20 text-grey-700"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile2 = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile2 === void 0 ? void 0 : _selectedViewFiles_currentFile2.url,
                                                download: true,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                    className: "px-3 py-2",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                        className: "mrv mrv-download text-fs-20 text-grey-700"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                className: "px-3 py-2",
                                                onClick: ()=>{
                                                    if (currentRotate == 180) {
                                                        setCurrentRotate(-90);
                                                    } else {
                                                        setCurrentRotate(currentRotate + 90);
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                    className: "mrv mrv-rotate_90_degrees_cw text-fs-20 text-grey-700"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                className: "px-3 py-2",
                                                onClick: ()=>{
                                                    if (currentRotate == -90) {
                                                        setCurrentRotate(180);
                                                    } else {
                                                        setCurrentRotate(currentRotate - 90);
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                    className: "mrv mrv-rotate_90_degrees_ccw text-fs-20 text-grey-700"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: ()=>{
                                            var _selectedViewFiles_files;
                                            if (currentIndexFile < (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_files = selectedViewFiles.files) === null || _selectedViewFiles_files === void 0 ? void 0 : _selectedViewFiles_files.length) - 1) {
                                                resetTransform();
                                                setSelectedViewFiles({
                                                    ...selectedViewFiles,
                                                    currentFile: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files[currentIndexFile + 1]
                                                });
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("mrv mrv-chevron_right  text-fs-32 leading-[32px]", currentIndexFile == (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_files = selectedViewFiles.files) === null || _selectedViewFiles_files === void 0 ? void 0 : _selectedViewFiles_files.length) - 1 ? "cursor-not-allowed text-grey-100" : "text-white")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex-[1_1_auto] w-full flex justify-between items-center gap-6",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full h-full",
                                    children: (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile3 = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile3 === void 0 ? void 0 : _selectedViewFiles_currentFile3.mediaType) == _constants_enum_media__WEBPACK_IMPORTED_MODULE_11__/* .MediaTypeEnum.IMAGE.toString */ .L.IMAGE.toString() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_7__/* .TransformComponent */ .Uv, {
                                        contentClass: "!h-full !w-full flex justify-between items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-full h-full flex justify-center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: selectedViewFiles.currentFile.uri.match(_constants_file__WEBPACK_IMPORTED_MODULE_3__/* .fileType.resizeImageSupport */ .r.resizeImageSupport) ? (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .resizeOnFlyUrl */ .Li)({
                                                    uri: selectedViewFiles.currentFile.uri,
                                                    width: 0,
                                                    height: 0,
                                                    gravity: "ce",
                                                    resizingType: "auto"
                                                }) : selectedViewFiles.currentFile.url,
                                                alt: "test",
                                                className: "w-[inherit] h-full absolute object-contain",
                                                style: {
                                                    transform: "rotate(".concat(currentRotate, "deg)")
                                                }
                                            }, currentRotate)
                                        })
                                    }) : (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile4 = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile4 === void 0 ? void 0 : _selectedViewFiles_currentFile4.mediaType) == _constants_enum_media__WEBPACK_IMPORTED_MODULE_11__/* .MediaTypeEnum.VIDEO.toString */ .L.VIDEO.toString() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_7__/* .TransformComponent */ .Uv, {
                                        contentClass: "!h-full !w-full flex justify-between items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_VideoPlayer__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            options: {
                                                autoplay: true,
                                                muted: true,
                                                controls: true,
                                                responsive: true,
                                                fluid: true,
                                                sources: [
                                                    {
                                                        src: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.urlVod
                                                    }
                                                ]
                                            }
                                        }, selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile5 = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile5 === void 0 ? void 0 : _selectedViewFiles_currentFile5.urlVod)
                                    }) : (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.name.match(_constants_file__WEBPACK_IMPORTED_MODULE_3__/* .fileType.viewFileSupport */ .r.viewFileSupport)) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_7__/* .TransformComponent */ .Uv, {
                                        contentClass: "!h-full !w-full flex justify-between items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ReviewInputComponent_tsx_DocViewerPreview__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                            url: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.url
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_7__/* .TransformComponent */ .Uv, {
                                        contentClass: "!h-full !w-full flex justify-center items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-[685px] h-[196px] rounded-xl p-6 flex flex-col justify-center gap-4 bg-grey-100",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex items-center gap-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                            className: "mrv mrv-docs text-fs-36 text-grey-700"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex flex-col text-grey-700",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "text-base font-medium text-grey-800 line-clamp-1 break-words w-full",
                                                                    title: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.name,
                                                                    children: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.name
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                    className: "text-fs-12",
                                                                    children: [
                                                                        (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.size) / 1000,
                                                                        " MB"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-fs-20 text-grey-800 font-semibold",
                                                    children: "Kh\xf4ng thể xem trước tệp n\xe0y. Vui l\xf2ng tải xuống để xem nội dung"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile6 = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile6 === void 0 ? void 0 : _selectedViewFiles_currentFile6.url,
                                                    download: true,
                                                    target: "_blank",
                                                    className: "flex justify-center w-full",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                        className: "meey-button meey-button-primary meey-button-filled py-2.5 px-4 h-11 flex items-center gap-1 w-fit ",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "mrv mrv-download text-fs-20"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "text-fs-16 font-semibold",
                                                                children: "Tải xuống"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                ref: parentListRef,
                                className: "py-2 rounded-lg text-fs-12 text-grey-600 flex max-w-[100%] mx-auto flex-nowrap overflow-auto gap-2 flex-[0_0_auto] ",
                                children: (selectedViewFiles.maxFileShow ? selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_files1 = selectedViewFiles.files) === null || _selectedViewFiles_files1 === void 0 ? void 0 : _selectedViewFiles_files1.slice(currentIndexFile, currentIndexFile + selectedViewFiles.maxFileShow) : selectedViewFiles.files).map((file, index)=>{
                                    var _selectedViewFiles_currentFile, _file_name_split;
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        ref: (el)=>itemsRef.current[index] = el,
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("relative group cursor-pointer h-fit flex-0 rounded-lg duration-300 border-2", file.mediaType == _constants_enum_media__WEBPACK_IMPORTED_MODULE_11__/* .MediaTypeEnum.IMAGE.toString */ .L.IMAGE.toString() || file.mediaType == _constants_enum_media__WEBPACK_IMPORTED_MODULE_11__/* .MediaTypeEnum.VIDEO.toString */ .L.VIDEO.toString() ? "can-preview-upload" : "default-file", file.s3Key === ((_selectedViewFiles_currentFile = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile === void 0 ? void 0 : _selectedViewFiles_currentFile.s3Key) ? " !border-blue-500" : ""),
                                        onClick: ()=>{
                                            var _itemsRef_current;
                                            resetTransform();
                                            parentListRef.current.scrollTo({
                                                left: ((_itemsRef_current = itemsRef.current) === null || _itemsRef_current === void 0 ? void 0 : _itemsRef_current[index].offsetLeft) - 30,
                                                behavior: "smooth"
                                            });
                                            setSelectedViewFiles({
                                                ...selectedViewFiles,
                                                currentFile: file
                                            });
                                        },
                                        children: file.mediaType == _constants_enum_media__WEBPACK_IMPORTED_MODULE_11__/* .MediaTypeEnum.IMAGE.toString */ .L.IMAGE.toString() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-[4.5rem] h-[4.5rem] bg-grey-200 rounded-md flex flex-col relative cursor-pointer",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: " text-fs-12 w-full h-full overflow-hidden rounded-md",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MeeyImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                    className: "object-cover w-full h-full",
                                                    src: file.uri,
                                                    alt: file.name,
                                                    resizeOnFly: !!(file === null || file === void 0 ? void 0 : file.uri),
                                                    resizeOptions: {
                                                        width: 72,
                                                        height: 72
                                                    }
                                                })
                                            })
                                        }) : file.mediaType == _constants_enum_media__WEBPACK_IMPORTED_MODULE_11__/* .MediaTypeEnum.VIDEO.toString */ .L.VIDEO.toString() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-[4.5rem] h-[4.5rem] bg-grey-200 rounded-md flex flex-col relative cursor-pointer",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: " text-fs-12 w-full h-full overflow-hidden rounded-b-md",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_VideoPlayer__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                        options: {
                                                            autoplay: false,
                                                            muted: true,
                                                            controls: false,
                                                            responsive: true,
                                                            preload: "metadata",
                                                            fluid: true,
                                                            sources: [
                                                                {
                                                                    src: file.urlVod
                                                                }
                                                            ]
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                            className: "mrv mrv-play_arrow text-white text-fs-24 font-bold"
                                                        })
                                                    })
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-[4.5rem] h-[4.5rem] bg-grey-200 rounded-md flex flex-col relative cursor-pointer border border-transparent border-dashed",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex-[0_0_36px] w-full flex items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "-rotate-90 w-fit mr-2",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "mrv mrv-attachment text-fs-20 "
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            children: [
                                                                ".",
                                                                (_file_name_split = file.name.split(".")) === null || _file_name_split === void 0 ? void 0 : _file_name_split.pop()
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "bg-grey-300 flex-[1_1_auto] text-fs-12 py-1 px-2 overflow-hidden rounded-b-md",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "line-clamp-2",
                                                        children: file.name
                                                    })
                                                })
                                            ]
                                        })
                                    }, file.s3Key);
                                })
                            })
                        ]
                    });
                }
            })
        }) : null
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalViewDetailFile);


/***/ }),

/***/ 18858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_AvatarWithName__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7869);
/* harmony import */ var _constants_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24435);
/* harmony import */ var _context_project_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12482);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33172);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);






let timeOutOpenUpload = null;
let timeOuteEmoji = null;
const BoxReply = (param)=>{
    let { data  } = param;
    const { user  } = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .a)();
    const { setCurrentShowFormReply , currentShowFormReply , refUpload , loadingSendReply  } = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(_context_project_context__WEBPACK_IMPORTED_MODULE_3__/* .ProjectContext */ .x);
    var _user_name;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex items-center gap-3 w-full my-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AvatarWithName__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                imageProps: {
                    resizeOnFly: false
                },
                src: (user === null || user === void 0 ? void 0 : user.avatar) ? user === null || user === void 0 ? void 0 : user.avatar : (user === null || user === void 0 ? void 0 : user.name) ? null : _constants_image__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_IMAGE_CARD */ .mq,
                name: (_user_name = user === null || user === void 0 ? void 0 : user.name) !== null && _user_name !== void 0 ? _user_name : "Ẩn danh",
                avatarOnly: true,
                imageClass: "!w-10 !h-10",
                textClass: "!text-white font-medium select-none",
                className: "shrink-0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center justify-between border border-solid border-grey-200 pl-4 pr-3 text-fs-14 text-grey-400 rounded-full w-full h-10 md:cursor-pointer bg-grey-50",
                onClick: (e)=>{
                    if (!loadingSendReply) {
                        e.stopPropagation();
                        if (currentShowFormReply !== data._id) setCurrentShowFormReply(data._id);
                        else setCurrentShowFormReply(null);
                    }
                },
                children: [
                    "Phản hồi của bạn",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-9 w-9 flex items-center justify-center hover:bg-blue-100 hover:rounded-full",
                                onClick: (e)=>{
                                    if (!loadingSendReply) {
                                        e.stopPropagation();
                                        setCurrentShowFormReply(data._id);
                                        if (timeOutOpenUpload) clearTimeout(timeOutOpenUpload);
                                        timeOutOpenUpload = setTimeout(()=>{
                                            var _refUpload_current;
                                            refUpload === null || refUpload === void 0 ? void 0 : (_refUpload_current = refUpload.current) === null || _refUpload_current === void 0 ? void 0 : _refUpload_current.click();
                                        });
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: "mrv mrv-add_photo_alternate text-blue-400 text-fs-18"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-9 w-9 items-center justify-center hover:bg-blue-100 hover:rounded-full hidden md:flex",
                                onClick: (e)=>{
                                    if (!loadingSendReply) {
                                        e.stopPropagation();
                                        setCurrentShowFormReply(data._id);
                                        if (timeOuteEmoji) clearTimeout(timeOuteEmoji);
                                        timeOuteEmoji = setTimeout(()=>{
                                            var _document_getElementById;
                                            (_document_getElementById = document.getElementById("btn-emoji")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.click();
                                        });
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: "mrv mrv-mood text-orange-400 text-fs-18 "
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BoxReply);


/***/ }),

/***/ 8971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ListReplyReview_FormReplyReview; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/AvatarWithName.tsx
var AvatarWithName = __webpack_require__(7869);
// EXTERNAL MODULE: ./src/components/Button.tsx + 1 modules
var Button = __webpack_require__(40364);
// EXTERNAL MODULE: ./src/constants/common-constant.ts
var common_constant = __webpack_require__(17785);
// EXTERNAL MODULE: ./src/constants/environment.ts
var environment = __webpack_require__(7181);
// EXTERNAL MODULE: ./src/constants/file.ts
var file = __webpack_require__(32336);
// EXTERNAL MODULE: ./src/constants/image.ts
var constants_image = __webpack_require__(24435);
// EXTERNAL MODULE: ./src/context/project.context.tsx
var project_context = __webpack_require__(12482);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 2 modules
var useAuth = __webpack_require__(33172);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 28 modules
var es_form = __webpack_require__(75632);
// EXTERNAL MODULE: ./node_modules/antd/es/notification/index.js + 5 modules
var notification = __webpack_require__(54689);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 18 modules
var input = __webpack_require__(79415);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants/enum/media.ts
var media = __webpack_require__(71381);
// EXTERNAL MODULE: ./src/components/PopOver/index.tsx + 2 modules
var PopOver = __webpack_require__(20951);
// EXTERNAL MODULE: ./src/context/device.context.tsx
var device_context = __webpack_require__(99757);
// EXTERNAL MODULE: ./src/utils/html.ts
var html = __webpack_require__(63704);
// EXTERNAL MODULE: ./node_modules/@emoji-mart/data/sets/14/native.json
var _14_native = __webpack_require__(26638);
// EXTERNAL MODULE: ./node_modules/@emoji-mart/data/i18n/vi.json
var vi = __webpack_require__(11070);
// EXTERNAL MODULE: ./node_modules/@emoji-mart/react/dist/module.js
var dist_module = __webpack_require__(73814);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-mentions/dist/react-mentions.esm.js + 31 modules
var react_mentions_esm = __webpack_require__(88540);
;// CONCATENATED MODULE: ./src/modules/common/ProjectDetail/ReviewItem/ListReplyReview/FormReplyReview/InputReplyReview.tsx
// import HeaderHome from "./HeaderHome";
// import Newest from "./Newest";














// import UploadReviewFile from "@/components/ReviewInputComponent.tsx/UploadReviewFile";
const UploadReviewFile = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(8762), __webpack_require__.e(8703), __webpack_require__.e(2540), __webpack_require__.e(3606)]).then(__webpack_require__.bind(__webpack_require__, 32540)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(32540)
            ]
    },
    ssr: false
});
const InputReplyReview = (param)=>{
    let { data  } = param;
    const form = es_form/* default.useFormInstance */.Z.useFormInstance();
    const commentValue = es_form/* default.useWatch */.Z.useWatch("comment", form);
    const { isMobile  } = (0,react.useContext)(device_context/* DeviceContext */.T);
    const [focus, setFocus] = (0,react.useState)(false);
    const [poinerSelect, setPointerSelect] = (0,react.useState)({
        selectionStart: 0,
        selectionEnd: 0
    });
    const { loadingSendReply , setLoadingSendReply  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const inputRef = (0,react.useRef)(null);
    const { user  } = (0,useAuth/* useAuth */.a)();
    const metionsUser = {
        userId: data.createdBy._id,
        nickName: data.nickName || ""
    };
    // useEffect(() => {
    //   formRef.current.scrollIntoView(false);
    //   inputRef.current.focus();
    // }, []);
    (0,react.useEffect)(()=>{
        var _inputRef_current, _inputRef_current_inputElement;
        form.setFieldsValue({
            nickName: user === null || user === void 0 ? void 0 : user.name,
            comment: "@{{".concat(data.createdBy._id, "||").concat(data.nickName ? data.nickName : "anymos", "}} ")
        });
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : (_inputRef_current_inputElement = _inputRef_current.inputElement) === null || _inputRef_current_inputElement === void 0 ? void 0 : _inputRef_current_inputElement.focus();
    }, [
        data.createdBy,
        data.createdBy._id,
        data.nickName,
        form,
        user === null || user === void 0 ? void 0 : user.name
    ]);
    // console.log(data, reviewItem);
    const replyLength = (0,react.useMemo)(()=>{
        var _exactCommentString_trim, _exactCommentString;
        return commentValue ? (_exactCommentString_trim = (_exactCommentString = (0,html/* exactCommentString */.r$)(commentValue, [
            {
                userId: data.createdBy._id,
                nickName: data.nickName
            }
        ])) === null || _exactCommentString === void 0 ? void 0 : _exactCommentString.trim()) === null || _exactCommentString_trim === void 0 ? void 0 : _exactCommentString_trim.length : 0;
    }, [
        commentValue,
        data.createdBy._id,
        data.nickName
    ]);
    const fileList = es_form/* default.useWatch */.Z.useWatch("file", form);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)("border px-[13px] pt-3 pb-1 rounded-md review-input duration-300 overflow-auto w-full", focus ? "ant-input ant-input-focused" : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                    name: "comment",
                    className: "mb-0",
                    rules: [
                        {
                            validator (rule, value, callback) {
                                var _value_trim;
                                if (((_value_trim = value === null || value === void 0 ? void 0 : value.trim()) === null || _value_trim === void 0 ? void 0 : _value_trim.length) || (fileList === null || fileList === void 0 ? void 0 : fileList.length)) return Promise.resolve(true);
                            }
                        }
                    ],
                    getValueFromEvent: (e)=>{
                        const txt = e.target.value;
                        // console.log(txt.match(regex));
                        const useTagString = metionsUser.nickName ? "@{{".concat(metionsUser.userId, "||").concat(metionsUser.nickName, "}}") : "@{{".concat(metionsUser.userId, "||anymos}}");
                        const userTagText = metionsUser.nickName ? "@".concat(metionsUser.nickName) : "@Ẩn danh";
                        let returnString = "";
                        let fromindex = -1;
                        do {
                            const indexFind = txt.indexOf(useTagString, fromindex + 1);
                            const realCurrentString = (0,html/* exactCommentString */.r$)(returnString, [
                                metionsUser
                            ]);
                            if (indexFind >= 0) {
                                if (realCurrentString.length + txt.slice(fromindex === -1 ? 0 : fromindex + useTagString.length, indexFind).length + userTagText.length >= 2000) {
                                    returnString += txt.slice(fromindex === -1 ? 0 : fromindex + useTagString.length, indexFind - (fromindex + useTagString.length) >= 2000 - realCurrentString.length ? fromindex + useTagString.length + 2000 - realCurrentString.length : indexFind);
                                    break;
                                } else {
                                    returnString += txt.slice(fromindex === -1 ? 0 : fromindex + useTagString.length, indexFind) + useTagString;
                                }
                            } else {
                                returnString += txt.slice(fromindex === -1 ? 0 : fromindex + useTagString.length, 2000 - realCurrentString.length + fromindex + useTagString.length);
                            }
                            fromindex = indexFind;
                        }while (fromindex >= 0);
                        return returnString;
                    },
                    validateFirst: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_mentions_esm/* MentionsInput */.r, {
                        spellCheck: false,
                        ref: inputRef,
                        onFocus: ()=>{
                            setFocus(true);
                        },
                        rows: 3,
                        onBlur: ()=>{
                            var _inputRef_current, _inputRef_current1;
                            if (inputRef.current) setPointerSelect({
                                selectionEnd: (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.inputElement.selectionEnd,
                                selectionStart: (_inputRef_current1 = inputRef.current) === null || _inputRef_current1 === void 0 ? void 0 : _inputRef_current1.inputElement.selectionStart
                            });
                            setFocus(false);
                        },
                        onPaste: ()=>{
                            console.log("fsdfsdfh");
                        },
                        placeholder: "Nhập phản hồi",
                        disabled: loadingSendReply,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_mentions_esm/* Mention */.p, {
                            style: {
                                // color: "#3F82EE",
                                backgroundColor: "#DCEBFB"
                            },
                            markup: "@{{__id__||__display__}}",
                            trigger: "@",
                            data: [
                                {
                                    id: data.createdBy._id,
                                    display: data.nickName ? data.nickName : "anymos"
                                }
                            ],
                            displayTransform: (_id, display)=>{
                                // console.log(url);
                                return "@".concat(display === "anymos" ? "Ẩn danh" : display);
                            },
                            renderSuggestion: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden",
                                    children: data.display
                                })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                    name: "file",
                    noStyle: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadReviewFile, {
                        type: "upload",
                        setLoading: setLoadingSendReply,
                        showPreview: false,
                        loading: loadingSendReply
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                    noStyle: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "p-2 cursor-pointer text-grey-400",
                                        onClick: ()=>{
                                            if (!loadingSendReply) {
                                                var _document_getElementById;
                                                (_document_getElementById = document.getElementById("btn")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.click();
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "mrv mrv-attach_file text-fs-18"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "p-2 cursor-pointer text-grey-400",
                                        onClick: ()=>{
                                            if (!loadingSendReply) {
                                                var _document_getElementById;
                                                (_document_getElementById = document.getElementById("btn")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.click();
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "mrv mrv-add_photo_alternate text-fs-18 "
                                        })
                                    }),
                                    isMobile ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(PopOver/* default */.Z, {
                                        position: "left-top",
                                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_module/* default */.Z, {
                                            data: _14_native,
                                            onEmojiSelect: async (value)=>{
                                                var _inputRef_current;
                                                const textarea = (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.inputElement;
                                                const mentionValue = data.nickName ? "@{{".concat(data.createdBy._id, "||").concat(data.nickName, "}}") : "@{{".concat(data.createdBy._id, "||anymos}}");
                                                const mentionShow = data.nickName ? "@".concat(data.nickName) : "@Ẩn danh";
                                                // const realValue = exactCommentString(
                                                //   commentValue,
                                                //   [
                                                //     {
                                                //       userId: data.createdBy._id,
                                                //       nickName: data.nickName,
                                                //     },
                                                //   ]
                                                // );
                                                const index = commentValue.indexOf(mentionValue);
                                                if ((poinerSelect.selectionStart - index) * (poinerSelect.selectionEnd * (index + mentionValue.length)) < 0) return;
                                                let start;
                                                let end;
                                                if (poinerSelect.selectionStart < index) {
                                                    start = commentValue.substring(0, poinerSelect.selectionStart);
                                                    end = commentValue.substring(poinerSelect.selectionEnd);
                                                } else {
                                                    start = commentValue.substring(0, poinerSelect.selectionStart + mentionValue.length - mentionShow.length);
                                                    end = commentValue.substring(poinerSelect.selectionEnd + mentionValue.length - mentionShow.length);
                                                }
                                                const text = start + value.native + end;
                                                if ((0,html/* exactCommentString */.r$)(text, [
                                                    metionsUser
                                                ]).length < 2000) {
                                                    form.setFieldValue("comment", text);
                                                    form.validateFields([
                                                        "comment"
                                                    ]);
                                                    textarea.focus();
                                                    await Promise.resolve();
                                                    textarea.selectionStart = textarea.selectionEnd = poinerSelect.selectionStart + value.native.length;
                                                }
                                            },
                                            i18n: vi
                                        }),
                                        trigger: "click",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "p-2 cursor-pointer text-grey-400",
                                            type: "button",
                                            id: "btn-emoji",
                                            disabled: loadingSendReply,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "mrv mrv-sentiment_very_satisfied text-fs-18 text-orange-400"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-[11px] text-grey-400",
                                children: [
                                    replyLength,
                                    " / 2000"
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var FormReplyReview_InputReplyReview = (InputReplyReview);

;// CONCATENATED MODULE: ./src/modules/common/ProjectDetail/ReviewItem/ListReplyReview/FormReplyReview/index.tsx
// import HeaderHome from "./HeaderHome";
// import Newest from "./Newest";












// import UploadReviewFile from "@/components/ReviewInputComponent.tsx/UploadReviewFile";


const FormReplyReview = (param)=>{
    let { data , reviewItem , reviewIndex  } = param;
    const [form] = es_form/* default.useForm */.Z.useForm();
    const { setCurrentShowFormReply , handleSyncNumberReview , listReviewsIds , loadingSendReply , setLoadingSendReply , setListReviewIds  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const formRef = (0,react.useRef)(null);
    const { user , userDataHeader  } = (0,useAuth/* useAuth */.a)();
    const { setProjectListVote , currentRefItem , projectListVote , reviewDetail , setReviewDetail  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const timeOutBachground = (0,react.useRef)(null);
    var _user_name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mt-2 flex gap-3 items-start",
            ref: formRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarWithName/* default */.Z, {
                    imageClass: "md:!w-10 md:!h-10 !w-8 !h-8",
                    imageProps: {
                        resizeOnFly: false
                    },
                    className: "flex-0 ",
                    avatarOnly: true,
                    alt: (_user_name = user === null || user === void 0 ? void 0 : user.name) !== null && _user_name !== void 0 ? _user_name : "Ẩn danh",
                    name: user === null || user === void 0 ? void 0 : user.name,
                    src: (user === null || user === void 0 ? void 0 : user.avatar) ? user === null || user === void 0 ? void 0 : user.avatar : (user === null || user === void 0 ? void 0 : user.name) ? null : constants_image/* DEFAULT_IMAGE_CARD */.mq
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex-1 overflow-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
                        form: form,
                        initialValues: {
                            nickName: "",
                            comment: ""
                        },
                        onFinish: async (value)=>{
                            setLoadingSendReply(true);
                            try {
                                var _value_file, _value_file1, _value_comment, _res_data;
                                const mediaFile = (value === null || value === void 0 ? void 0 : value.file) && (value === null || value === void 0 ? void 0 : (_value_file = value.file) === null || _value_file === void 0 ? void 0 : _value_file.length) ? value === null || value === void 0 ? void 0 : (_value_file1 = value.file) === null || _value_file1 === void 0 ? void 0 : _value_file1.map((item)=>{
                                    if (item.name.match(file/* fileType.file */.r.file)) {
                                        return {
                                            type: media/* MediaTypeEnum.FILE */.L.FILE,
                                            s3Keys: [
                                                item.s3Key
                                            ]
                                        };
                                    }
                                    if (item.name.match(file/* fileType.image */.r.image)) {
                                        return {
                                            type: media/* MediaTypeEnum.IMAGE */.L.IMAGE,
                                            s3Keys: [
                                                item.s3Key
                                            ]
                                        };
                                    }
                                    if (item.name.match(file/* fileType.video */.r.video)) {
                                        return {
                                            type: media/* MediaTypeEnum.VIDEO */.L.VIDEO,
                                            s3Keys: [
                                                item.s3Key
                                            ]
                                        };
                                    }
                                }) : [];
                                var _value_nickName;
                                const res = await axios/* default.request */.Z.request({
                                    method: "post",
                                    baseURL: environment/* MEEY_REVIEW_API_URL */.HG,
                                    url: "v1/comments/" + reviewItem._id + "/reply",
                                    headers: {
                                        ...userDataHeader
                                    },
                                    data: {
                                        nickName: "".concat((_value_nickName = value.nickName) !== null && _value_nickName !== void 0 ? _value_nickName : ""),
                                        comment: (_value_comment = value.comment) === null || _value_comment === void 0 ? void 0 : _value_comment.trim(),
                                        links: value.comment.match(common_constant/* urlRegex */.yV) || [],
                                        mentions: value.comment.includes("@{{".concat(data.createdBy._id, "||").concat(data.nickName ? data.nickName : "anymos", "}}")) ? [
                                            {
                                                userId: data.createdBy._id,
                                                nickName: data.nickName || ""
                                            }
                                        ] : [],
                                        media: mediaFile
                                    }
                                });
                                // thêm id của reply mới vào listReviewIds
                                setListReviewIds([
                                    ...listReviewsIds,
                                    res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data._id
                                ]);
                                setProjectListVote({
                                    ...projectListVote,
                                    results: projectListVote.results.map((review)=>{
                                        if (review._id === reviewItem._id) return {
                                            ...review,
                                            replies: [
                                                ...review.replies,
                                                res.data
                                            ],
                                            totalReply: review.totalReply + 1
                                        };
                                        else return review;
                                    })
                                });
                                setCurrentShowFormReply(null);
                                // chi tiết review
                                if (res && reviewDetail) {
                                    setReviewDetail(reviewDetail.map((item)=>{
                                        return {
                                            ...item,
                                            replies: [
                                                ...item.replies,
                                                res.data
                                            ]
                                        };
                                    }));
                                }
                                await handleSyncNumberReview();
                                setTimeout(()=>{
                                    if (currentRefItem.current[reviewIndex]) {
                                        var _currentRefItem_current_reviewIndex_getElementsByClassName_item, _currentRefItem_current_reviewIndex_getElementsByClassName;
                                        window.scrollTo({
                                            behavior: "smooth",
                                            top: currentRefItem.current[reviewIndex].offsetTop + currentRefItem.current[reviewIndex].clientHeight - window.innerHeight
                                        });
                                        const lastedRepltItenm = (_currentRefItem_current_reviewIndex_getElementsByClassName_item = (_currentRefItem_current_reviewIndex_getElementsByClassName = currentRefItem.current[reviewIndex].getElementsByClassName("reply-review-list")) === null || _currentRefItem_current_reviewIndex_getElementsByClassName === void 0 ? void 0 : _currentRefItem_current_reviewIndex_getElementsByClassName.item(0)) === null || _currentRefItem_current_reviewIndex_getElementsByClassName_item === void 0 ? void 0 : _currentRefItem_current_reviewIndex_getElementsByClassName_item.lastChild;
                                        if (lastedRepltItenm) {
                                            lastedRepltItenm.style.background = "#EBF3FC";
                                            if (timeOutBachground) clearTimeout(timeOutBachground.current);
                                            timeOutBachground.current = setTimeout(()=>{
                                                lastedRepltItenm.style.background = "white";
                                            }, 2000);
                                        }
                                    }
                                }, 0);
                            } catch (error) {
                                var _error_response, _error_response_data;
                                if ((error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.code) === 400) {
                                    var _error_response1, _error_response_data1;
                                    form.setFields([
                                        {
                                            name: "comment",
                                            errors: [
                                                error === null || error === void 0 ? void 0 : (_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : (_error_response_data1 = _error_response1.data) === null || _error_response_data1 === void 0 ? void 0 : _error_response_data1.message
                                            ]
                                        }
                                    ]);
                                } else notification/* default.error */.Z.error({
                                    message: "C\xf3 lỗi xảy ra, vui l\xf2ng thử lại sau",
                                    style: {
                                        width: "100%",
                                        top: 56
                                    }
                                });
                            } finally{
                                setTimeout(()=>{
                                    setLoadingSendReply(false);
                                }, 0);
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                name: "nickName",
                                className: "mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                    // ref={inputRef}
                                    placeholder: "Nick name của bạn",
                                    size: "large",
                                    maxLength: 50,
                                    disabled: loadingSendReply
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormReplyReview_InputReplyReview, {
                                data: data,
                                reviewItem: reviewItem
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-end gap-2 mt-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        btnType: "link",
                                        color: "grey",
                                        disabled: loadingSendReply,
                                        onClick: ()=>{
                                            setCurrentShowFormReply(null);
                                        },
                                        children: "Hủy"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                        noStyle: true,
                                        shouldUpdate: true,
                                        children: (param)=>{
                                            let { getFieldsError , isFieldTouched , getFieldValue  } = param;
                                            var _getFieldValue, _getFieldValue1;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                btnType: "filled",
                                                type: "button",
                                                onClick: form.submit,
                                                className: "!px-3",
                                                loading: loadingSendReply,
                                                disabled: loadingSendReply || !((_getFieldValue = getFieldValue([
                                                    "comment"
                                                ])) === null || _getFieldValue === void 0 ? void 0 : _getFieldValue.trim()) && !((_getFieldValue1 = getFieldValue([
                                                    "file"
                                                ])) === null || _getFieldValue1 === void 0 ? void 0 : _getFieldValue1.length) || getFieldsError().some((param)=>{
                                                    let { errors  } = param;
                                                    return errors.length;
                                                }),
                                                children: "Đăng phản hồi"
                                            });
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ListReplyReview_FormReplyReview = (FormReplyReview);


/***/ }),

/***/ 54973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ReviewItem_ReportModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Button.tsx + 1 modules
var Button = __webpack_require__(40364);
// EXTERNAL MODULE: ./src/components/Modal/index.tsx
var Modal = __webpack_require__(52591);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/SuccessIcon.tsx


function SuccessIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#27A435",
            d: "M10.525 14.275l-2.45-2.45a.748.748 0 00-.55-.225c-.217 0-.4.075-.55.225a.804.804 0 00-.25.588c0 .224.075.412.225.562l3.05 3.05a.71.71 0 00.525.2.71.71 0 00.525-.2l6-6a.748.748 0 00.225-.55.79.79 0 00-.25-.575.763.763 0 00-.563-.225.804.804 0 00-.587.25l-5.35 5.35zM12 22c-1.417 0-2.733-.254-3.95-.762a9.761 9.761 0 01-3.175-2.113 9.76 9.76 0 01-2.112-3.175C2.254 14.733 2 13.417 2 12c0-1.4.254-2.708.763-3.925A9.76 9.76 0 014.875 4.9c.9-.9 1.958-1.608 3.175-2.125C9.267 2.258 10.583 2 12 2c1.4 0 2.708.258 3.925.775A9.927 9.927 0 0119.1 4.9c.9.9 1.608 1.958 2.125 3.175C21.742 9.292 22 10.6 22 12c0 1.417-.258 2.733-.775 3.95a9.927 9.927 0 01-2.125 3.175 9.76 9.76 0 01-3.175 2.113C14.708 21.745 13.4 22 12 22z"
        })
    });
}
/* harmony default export */ var components_SuccessIcon = (SuccessIcon);

// EXTERNAL MODULE: ./src/constants/environment.ts
var environment = __webpack_require__(7181);
// EXTERNAL MODULE: ./src/context/project.context.tsx
var project_context = __webpack_require__(12482);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 2 modules
var useAuth = __webpack_require__(33172);
// EXTERNAL MODULE: ./node_modules/antd/es/notification/index.js + 5 modules
var notification = __webpack_require__(54689);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
;// CONCATENATED MODULE: ./src/modules/common/ProjectDetail/ReviewItem/ReportModal.tsx
// import HeaderHome from "./HeaderHome";
// import Newest from "./Newest";










const ReportModal = ()=>{
    const { currentShowFormReport , setCurrentShowFormReport  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const [contentReport, setContentReport] = (0,react.useState)("");
    const [loading, setLoading] = (0,react.useState)(false);
    const { token  } = (0,useAuth/* useAuth */.a)();
    (0,react.useEffect)(()=>{
        setContentReport("");
    }, [
        currentShowFormReport
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: !!currentShowFormReport,
        className: "z-[4000]",
        headerClassName: "!bg-white border-b border-b-grey-100 !px-4",
        header: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex text-blue-600 gap-2 items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "mrv mrv-report text-fs-24"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-fs-20",
                    children: "B\xe1o c\xe1o"
                })
            ]
        }),
        onClose: ()=>setCurrentShowFormReport(null),
        footerClassName: "!border-t-0",
        footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            btnType: "filled",
            onClick: async ()=>{
                setLoading(true);
                try {
                    await axios/* default.request */.Z.request({
                        method: "post",
                        baseURL: environment/* MEEY_REVIEW_API_URL */.HG,
                        headers: {
                            Authorization: "Bearer ".concat(token)
                        },
                        url: "v1/reports/create",
                        data: {
                            comment: currentShowFormReport,
                            content: contentReport
                        }
                    });
                    notification/* default.success */.Z.success({
                        message: "Cảm ơn bạn đ\xe3 gửi b\xe1o c\xe1o cho ch\xfang t\xf4i",
                        style: {
                            width: "fit-content",
                            top: 56,
                            zIndex: 500
                        },
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SuccessIcon, {})
                    });
                } catch (error) {
                    var _error_response, _error_response_data;
                    var _error_response_data_message;
                    notification/* default.error */.Z.error({
                        message: (_error_response_data_message = (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) !== null && _error_response_data_message !== void 0 ? _error_response_data_message : "C\xf3 lỗi xảy ra, vui l\xf2ng thử lại sau",
                        style: {
                            width: "100%",
                            top: 56,
                            zIndex: 500
                        }
                    });
                } finally{
                    setCurrentShowFormReport(null);
                    setLoading(false);
                }
            },
            loading: loading,
            color: "primary",
            disabled: !contentReport.trim().length || loading,
            children: "Gửi b\xe1o c\xe1o"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col sm:w-[26rem] w-[90vw]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    className: "text-fs-14 font-normal text-grey-700 mb-4",
                    htmlFor: "Vui l\xf2ng nhập l\xfd do vi phạm:",
                    children: "Vui l\xf2ng nhập l\xfd do vi phạm:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                    value: contentReport,
                    onChange: (e)=>{
                        var _e_target_value;
                        return setContentReport((_e_target_value = e.target.value) === null || _e_target_value === void 0 ? void 0 : _e_target_value.slice(0, 200));
                    },
                    rows: 6,
                    placeholder: "Nhập nội dung",
                    style: {
                        height: "auto"
                    },
                    className: "border border-grey-200 pt-2 pr-3 pb-1 pl-3 rounded-md"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-fs-12 flex justify-end text-grey-500",
                    children: [
                        contentReport.trim().length,
                        " / 200"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ReviewItem_ReportModal = (ReportModal);


/***/ }),

/***/ 38762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _constants_project_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18825);
/* harmony import */ var _components_MeeyRate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14759);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);





const ReviewDetailRate = (param)=>{
    let { data  } = param;
    const [expand, setExpand] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    return data.voteScore ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "p-2 bg-grey-50 rounded-lg text-fs-12 text-grey-600 cursor-pointer",
        onClick: ()=>setExpand((exp)=>!exp),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex gap-2 items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MeeyRate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        disable: true,
                        value: data === null || data === void 0 ? void 0 : data.voteScore,
                        itemClassName: "!text-fs-24",
                        className: "h-5 items-center"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-blue-500",
                        children: "Xem điểm chi tiết"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("flex gap-2 flex-wrap overflow-hidden duration-300 border-dashed ", expand ? "max-h-[10rem] pt-2  border-t mt-2" : "max-h-0"),
                children: _constants_project_constant__WEBPACK_IMPORTED_MODULE_1__/* .RATE_CATEGORY.filter */ .K2.filter((cate)=>{
                    var _data_votes_find;
                    return ((_data_votes_find = data.votes.find((item)=>item.voteCategory === cate.key)) === null || _data_votes_find === void 0 ? void 0 : _data_votes_find.score) > 0;
                }).map((cate)=>{
                    var _data_votes_find;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "px-2 py-0.5 rounded-full bg-grey-200 flex-[0_0_auto]",
                        children: [
                            cate.title,
                            ":",
                            " ",
                            (_data_votes_find = data.votes.find((item)=>item.voteCategory === cate.key)) === null || _data_votes_find === void 0 ? void 0 : _data_votes_find.score,
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: "mrv mrv-star text-fs-12"
                            })
                        ]
                    }, cate.key);
                })
            })
        ]
    }, data._id) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (ReviewDetailRate);


/***/ }),

/***/ 27083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_ReviewShowTextContent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54370);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
// import HeaderHome from "./HeaderHome";
// import Newest from "./Newest";




const maxlen = 500;
const ReviewDetailTextContent = (param)=>{
    let { data  } = param;
    const [showFull, setShowFull] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(1);
    const { query: { comment  }  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    // const rawText = useMemo(()=>{
    // })
    const rawTextContent = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>{
        var _data_mentions;
        let rawContentString = data.comment;
        (_data_mentions = data.mentions) === null || _data_mentions === void 0 ? void 0 : _data_mentions.forEach((mention)=>{
            rawContentString = rawContentString.replaceAll("@{{".concat(mention.userId, "||").concat(mention.nickName, "}}"), "@".concat(mention.nickName)).replaceAll("@{{".concat(mention.userId, "||anymos}}"), "@Ẩn danh");
        });
        return rawContentString;
    }, [
        data
    ]);
    return (rawTextContent === null || rawTextContent === void 0 ? void 0 : rawTextContent.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "mt-2 text-fs-14 !whitespace-pre-line inline-block",
        children: (rawTextContent === null || rawTextContent === void 0 ? void 0 : rawTextContent.length) > maxlen ? showFull * maxlen >= (rawTextContent === null || rawTextContent === void 0 ? void 0 : rawTextContent.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ReviewShowTextContent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            content: data.comment,
            mentions: data.mentions,
            limit: maxlen * showFull,
            searchString: comment
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ReviewShowTextContent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    content: data.comment,
                    mentions: data.mentions,
                    searchString: comment,
                    limit: maxlen * showFull
                }),
                !comment ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        "...",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-blue-500 cursor-pointer",
                            onClick: ()=>setShowFull(showFull + 1),
                            children: "xem th\xeam"
                        })
                    ]
                }) : null
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ReviewShowTextContent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            content: data.comment,
            mentions: data.mentions,
            searchString: comment,
            limit: null
        })
    }, data._id) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (ReviewDetailTextContent);


/***/ }),

/***/ 63704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r$": function() { return /* binding */ exactCommentString; }
/* harmony export */ });
/* unused harmony exports parseStringToHtml, removeErrorCharacter */
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25935);

const parseStringToHtml = (str)=>{
    if (!str || str.toString().length === 0) {
        return null;
    }
    const stringHtml = removeErrorCharacter(str.toString());
    return parse(stringHtml, {});
};
const removeErrorCharacter = (str)=>{
    return str.replaceAll("atarget", "a target");
};
const exactCommentString = (content, mentions)=>{
    let rawContentString = content;
    mentions === null || mentions === void 0 ? void 0 : mentions.forEach((mention)=>{
        rawContentString = rawContentString.replaceAll("@{{".concat(mention.userId, "||").concat(mention.nickName, "}}"), "@".concat(mention.nickName)).replaceAll("@{{".concat(mention.userId, "||anymos}}"), "@Ẩn danh");
    });
    return rawContentString;
};


/***/ }),

/***/ 14601:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 32767:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 28251:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 57677:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 87324:
/***/ (function() {

/* (ignored) */

/***/ })

}]);